export const SALESFORCE_CONTACT_EMAIL_KEY = 'salesforceContactEmail';

export const DEFAULT_DRAWER_WIDTH = '72%';

export const PUSHER_ENCRYPTED_CHANNEL_PREFIX = 'private-encrypted-';
